"use client";
import { useComboboxProviderContext } from "../combobox/combobox-context.js";
import { useCompositeStoreProps } from "../composite/composite-store.js";
import { useHovercardStoreProps } from "../hovercard/hovercard-store.js";
import { useMenubarContext } from "../menubar/menubar-context.js";
import { useMenuContext } from "./menu-context.js";
import { useUpdateEffect } from "@ariakit/react-utils";
import { useStore, useStoreProps } from "@ariakit/react-store";
import * as Core from "@ariakit/components/menu/menu-store";
//#region src/menu/menu-store.ts
function useMenuStoreProps(store, update, props) {
	useUpdateEffect(update, [
		props.combobox,
		props.parent,
		props.menubar
	]);
	useStoreProps(store, props, "values", "setValues");
	return Object.assign(useHovercardStoreProps(useCompositeStoreProps(store, update, props), update, props), {
		combobox: props.combobox,
		parent: props.parent,
		menubar: props.menubar
	});
}
function useMenuStore(props = {}) {
	const parent = useMenuContext();
	const menubar = useMenubarContext();
	const combobox = useComboboxProviderContext();
	props = {
		...props,
		parent: props.parent !== void 0 ? props.parent : parent,
		menubar: props.menubar !== void 0 ? props.menubar : menubar,
		combobox: props.combobox !== void 0 ? props.combobox : combobox
	};
	const [store, update] = useStore(Core.createMenuStore, props);
	return useMenuStoreProps(store, update, props);
}
//#endregion
export { useMenuStore, useMenuStoreProps };

//# sourceMappingURL=menu-store.js.map